var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-page"},[_c('div',{staticClass:"page-head"},[_c('wb-header')],1),_c('div',{staticClass:"page-content",style:(_vm.contentStyle)},[_vm._t("default")],2),_c('wb-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }